<div class="table-container thin-scrollbar">
  <table mat-table [dataSource]="dataSource" matSort class="mat-table">

    <ng-container matColumnDef="numEvaluation">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
      <td mat-cell *matCellDef="let eval">
        {{ eval.numEvaluation }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let eval">
        @if(eval.examen){
        <app-icon type="do" icon="groupe-commission" class="primary" matTooltip="Examen"></app-icon>
        }@else {
        <app-icon type="do" icon="evaluation" class="primary" matTooltip="Évaluation"></app-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="libelle">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Libellé </th>
      <td mat-cell *matCellDef="let eval">
        {{ eval.libelle }}
      </td>
    </ng-container>

    <ng-container matColumnDef="dateDebut">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> <app-icon type="do" icon="date-range"
          style="margin-right: 5px;" /> Date </th>
      <td mat-cell *matCellDef="let eval">
        @if(eval.dateDebut === eval.dateFin){
        {{ eval.dateDebut | date:'shortDate' }}
        }@else{
        Du {{ eval.dateDebut | date:'shortDate' }} au {{ eval.dateFin | date:'shortDate' }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="discipline">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><app-icon type="do" icon="discipline"
          style="margin-right: 5px;" /> Discipline </th>
      <td mat-cell *matCellDef="let eval"> {{ eval.discipline?.libelle }} </td>
    </ng-container>

    <ng-container matColumnDef="cours">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><app-icon type="do" icon="cours"
          style="margin-right: 5px;" /> Cours </th>
      <td mat-cell *matCellDef="let eval"> {{ eval.cours?.libelle }} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let eval">
        <button mat-icon-button color="accent" [routerLink]="'edit/' + eval.idEvaluation">
          <mat-icon>edit</mat-icon>
        </button>
        <!-- <button mat-icon-button color="warn" (click)="confirmDelete(eval)">
          <mat-icon>delete</mat-icon>
        </button> -->
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [ngClass]="{ 'row-leave': leavingRows.has(row.idEvaluation) }"></tr>

  </table>
</div>
<mat-divider></mat-divider>
<mat-paginator style="border-radius: 4px;" [length]="totalItems()" [pageIndex]="pageIndex()" [pageSize]="pageSize()"
  [pageSizeOptions]="pageSizeOptions()" (page)="onPageChange($event)">
</mat-paginator>